import { createContext, useContext } from 'react'

const createRequiredContext = <T>(name: string) => {
  const context = createContext<T | null>(null)

  const useRequiredContext = () => {
    const someContext = useContext<T | null>(context)

    if (!someContext) {
      throw new Error(`No context available for context ${name}`)
    }

    return someContext
  }

  return [useRequiredContext, context.Provider] as const
}

const createRequiredAndOptionalContext = <T>(name: string) => {
  const context = createContext<T | null>(null)

  const useRequiredContext = () => {
    const requiredContext = useContext(context)

    if (!requiredContext) {
      throw new Error(`No context available for context ${name}`)
    }

    return requiredContext
  }

  const useOptionalContext = () => {
    const optionalContext = useContext(context)

    return (optionalContext ?? {}) as unknown as Partial<T>
  }

  return [useRequiredContext, useOptionalContext, context.Provider] as const
}

export { createRequiredAndOptionalContext, createRequiredContext }
